const identity_token = (state = null, action) => {
	switch(action.type) {
		case 'SET_IDENTITY_TOKEN':
			return action.payload;
		default:
			return state;
	}
}

export default identity_token;